(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-liquid"] && !Shopify.designMode) return;
  try {
    /* Scroll infinito isolado: só mexe em elementos [data-flama-pgx-*].
     Pede a página seguinte à section que contém o bloco e procura nela
     o mesmo bloco pelo data-flama-pgx-block. */
  (function () {
    function setup(root) {
      if (root.getAttribute('data-flama-pgx-ready')) return;
      root.setAttribute('data-flama-pgx-ready', '1');

      var grid = root.querySelector('[data-flama-pgx-grid]');
      var sentinel = root.querySelector('[data-flama-pgx-sentinel]');
      if (!grid || !sentinel || !('IntersectionObserver' in window)) return;

      var busy = false;
      var observer;

      function loadNext() {
        var next = grid.getAttribute('data-flama-pgx-next');
        if (!next || busy) return;
        busy = true;

        var url = new URL(window.location.href);
        url.searchParams.set('section_id', root.getAttribute('data-flama-pgx-section'));
        url.searchParams.set('page', next);
        var blockId = root.getAttribute('data-flama-pgx-block');

        fetch(url.toString())
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newRoot = doc.querySelector('[data-flama-pgx-block="' + blockId + '"]');
            var newGrid = newRoot && newRoot.querySelector('[data-flama-pgx-grid]');
            if (!newGrid) {
              grid.setAttribute('data-flama-pgx-next', '');
              return;
            }
            Array.prototype.forEach.call(newGrid.children, function (card) {
              grid.appendChild(document.importNode(card, true));
            });
            grid.setAttribute('data-flama-pgx-next', newGrid.getAttribute('data-flama-pgx-next') || '');
          })
          .catch(function () {
            grid.setAttribute('data-flama-pgx-next', '');
          })
          .then(function () {
            busy = false;
            if (!grid.getAttribute('data-flama-pgx-next') && observer) observer.disconnect();
          });
      }

      observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) loadNext();
        },
        { rootMargin: '600px 0px' }
      );
      observer.observe(sentinel);
    }

    function setupAll() {
      var roots = document.querySelectorAll('[data-flama-pgx-root]');
      for (var i = 0; i < roots.length; i++) setup(roots[i]);
    }

    setupAll();
    document.addEventListener('shopify:section:load', setupAll);
    document.addEventListener('shopify:block:select', setupAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
